import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthenticationResponseJSON, PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  private http = inject(HttpClient);
  private API_HOST = environment.API_HOST;

  public magicLinkAuth(token: string): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http.post<{ accessToken: string; refreshToken: string }>(`${this.API_HOST}/web/auth/magic-link`, { token });
  }

  public telegramWebAuth(data: Record<string, any>, forSignUp: boolean): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http.post<{ accessToken: string; refreshToken: string }>(`${this.API_HOST}/web/auth/telegram`, {
      ...data,
      forSignUp,
    });
  }

  public getGoogleAuthUrl(mode: 'sign-in' | 'sign-up' | 'link'): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.API_HOST}/web/auth/google/url?mode=${mode}`);
  }

  public vkWebAuth(payload: { code: string; state: string; code_verifier: string; device_id: string; redirect_uri: string; forSignUp: boolean }): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http.post<{ accessToken: string; refreshToken: string }>(`${this.API_HOST}/web/auth/vk`, payload);
  }

  public refreshToken(refreshToken: string): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http.get<{ accessToken: string; refreshToken: string }>(`${this.API_HOST}/web/auth/telegram/refresh?refreshToken=${refreshToken}`);
  }

  public sendEmailVerificationCode(email: string): Observable<void> {
    return this.http.post<void>(`${this.API_HOST}/web/auth/email`, { email });
  }

  public verifyEmailVerificationCode(code: string): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http.post<{ accessToken: string; refreshToken: string }>(`${this.API_HOST}/web/auth/email/verify`, { code });
  }

  public startPasskeyLogin(): Observable<PublicKeyCredentialRequestOptionsJSON & { challengeKey: string }> {
    return this.http.post<PublicKeyCredentialRequestOptionsJSON & { challengeKey: string }>(`${this.API_HOST}/web/auth/passkey/authenticate/start`, {});
  }

  public verifyPasskeyLogin(data: AuthenticationResponseJSON & { challengeKey: string }): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http.post<{ accessToken: string; refreshToken: string }>(`${this.API_HOST}/web/auth/passkey/authenticate/verify`, data);
  }
}
